import React, { useState, useEffect } from "react";
import Barcode from "react-barcode";

export const MemberCard = (props) => {
  const [cardNumber, setCardNumber] = useState(0);
  const [memberNumber, setMemberNumber] = useState("");
  const [fullName, setFullName] = useState("");
  const [photo, setPhoto] = useState();

  const redirectHome = () =>{
    props.history.push('/home')
  }

  useEffect(() => {
    function getMemberDetails() {
      const cardNumberFromStorage = sessionStorage.getItem("cardNumber");
      const fullNameFromStorage = sessionStorage.getItem("fullName");
      const memberNumberFromStorage = sessionStorage.getItem("memberNumber");
      const photoFromStorage = sessionStorage.getItem("photo");
      setCardNumber(cardNumberFromStorage);
      setFullName(fullNameFromStorage);
      setMemberNumber(memberNumberFromStorage);
      setPhoto(photoFromStorage);
    }
    getMemberDetails();
  }, []);

  return (
    <div className="container points-page">
      <h2 className="text-center">
        <strong>Digital Card</strong>
      </h2>
      <div className="card-photo-div">
        <div>
            <img className="card-photo" src={`data:image/png;base64,${photo}`} alt='memberPhoto'/>
        </div>
      </div>
      <h4 className="text-center">{fullName}</h4>
      <h4 className="text-center" >{memberNumber}</h4>
      <div className="barcode-div">
        <Barcode value={cardNumber} format="CODE128" displayValue="false" />
      </div>
      <button className="form-btn btn btn-primary float-left formButton" onClick={redirectHome}>Back</button>


    </div>
  );
};
